(function () {
  var CODE = 'STAY5';
  var PCT = 5;
  var KEY = 'az_exit_offer_shown';
  var TEST = /[?&]exit_test=1/.test(location.search);
  var isTouch = window.matchMedia('(hover: none)').matches;
  var goingToCheckout = false;
  var busy = false;

  function seen() { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function markSeen() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }
  function track(name) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name });
    if (typeof window.clarity === 'function') window.clarity('event', name);
  }

  function tryShow(source) {
    if (busy || goingToCheckout || (!TEST && seen())) return;
    if (document.querySelector('.popup-modal--active')) return; // newsletter popup already open
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) { busy = false; return; } // only people with items in cart
        markSeen();
        render();
        track('exit_offer_shown');
        track('exit_offer_shown_' + source);
      })
      .catch(function () { busy = false; });
  }

  function render() {
    var o = document.createElement('div');
    o.id = 'az-exit-offer';
    o.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;';
    o.innerHTML =
      '<div style="background:#fff;max-width:380px;width:100%;border-radius:14px;padding:28px 22px 20px;text-align:center;position:relative;font-family:inherit;color:#121212;">' +
        '<button type="button" data-x aria-label="Close" style="position:absolute;top:8px;right:12px;background:none;border:0;font-size:26px;line-height:1;cursor:pointer;color:#555;">&times;</button>' +
        '<p style="font-size:20px;font-weight:700;margin:0 0 8px;">Your Quiet Room Is Waiting 🔇</p>' +
        '<p style="font-size:15px;margin:0 0 18px;">SAVE ' + PCT + '% off 🎁 Cart saved.</p>' +
        '<button type="button" data-apply style="display:inline-block;padding:12px 28px;border:0;border-radius:6px;background:#0083ff;color:#fff;font-size:15px;font-weight:700;cursor:pointer;margin-bottom:12px;">Claim ' + PCT + '% off &rarr;</button>' +        '<div style="display:flex;gap:8px;justify-content:center;align-items:center;margin-bottom:10px;">' +
          '<span style="background:#f3f3f3;padding:8px 14px;border-radius:6px;font-weight:700;letter-spacing:1px;">' + CODE + '</span>' +
          '<button type="button" data-copy style="padding:8px 12px;border:2px solid #0083ff;border-radius:6px;background:#fff;color:#0083ff;font-weight:600;cursor:pointer;">Copy code</button>' +
        '</div>' +
        '<p style="font-size:12px;color:#777;margin:0;">One use per customer.</p>' +
        '<button type="button" data-x style="background:none;border:0;color:#777;text-decoration:underline;font-size:13px;margin-top:10px;cursor:pointer;">No thanks</button>' +
      '</div>';
    document.body.appendChild(o);

    function close() { o.remove(); busy = false; }
    o.addEventListener('click', function (e) { if (e.target === o) { close(); track('exit_offer_dismissed'); } });
    o.querySelectorAll('[data-x]').forEach(function (b) { b.addEventListener('click', function () { close(); track('exit_offer_dismissed'); }); });
    o.querySelector('[data-apply]').addEventListener('click', function () {
      track('exit_offer_apply');
      goingToCheckout = true;
      location.href = '/discount/' + CODE + '?redirect=/checkout';
    });
    o.querySelector('[data-copy]').addEventListener('click', function () {
      var btn = this;
      track('exit_offer_copy');
      (navigator.clipboard ? navigator.clipboard.writeText(CODE) : Promise.reject()).then(function () {
        btn.textContent = 'Copied!';
      }, function () { btn.textContent = CODE; });
    });
  }

  // Don't treat going to checkout as leaving
  document.addEventListener('click', function (e) {
    if (e.target.closest('[name="checkout"], a[href*="/checkout"]')) goingToCheckout = true;
  }, true);

  // Desktop: mouse leaves toward the tabs / close button
  if (!isTouch) {
    var pageStart = Date.now();
    var lastY = null, movingUp = false, leaveTimer = null;
    document.addEventListener('mousemove', function (e) {
      if (lastY !== null) movingUp = e.clientY < lastY;
      lastY = e.clientY;
    });
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.clientY > 0) return;
      if (!movingUp || Date.now() - pageStart < 5000) return;
      leaveTimer = setTimeout(function () { tryShow('desktop'); }, 300);
    });
    document.addEventListener('mouseover', function () {
      if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = null; }
    });
  }

  // Mobile: shopper closes the cart drawer with items still in it
  if (isTouch) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var wasOpen = drawer.classList.contains('active');
      new MutationObserver(function () {
        var open = drawer.classList.contains('active');
        if (wasOpen && !open) setTimeout(function () { tryShow('mobile_drawer_close'); }, 400);
        wasOpen = open;
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (TEST) setTimeout(function () { tryShow('test'); }, 1500);
})();
